import { parseString } from "./ParseString";

export const copyTextToClipboard = async (text: string, toast: any, copyWithVerse: boolean, verse: string) => {
  const { book, chapter, verseStart, verseEnd } = parseString(verse);
  const reconstructedQueryString = `${book} ${chapter}${verseStart ? `:${verseStart}` : ""}${
    verseEnd ? `-${verseEnd}` : ""
  }`;  
  const textToCopy = copyWithVerse ? (`${text}  (${reconstructedQueryString})`) : text;
    try {
      if (!navigator.clipboard) {
        // Clipboard API not available, use document.execCommand as a fallback
        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      } else {
        // Use the Clipboard API
        await navigator.clipboard.writeText(textToCopy);
      }

      toast({
        title: "Copied!",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (err) {
      // Handle errors (e.g., clipboard permissions denied)
      toast({
        title: "Failed to copy with Clipboard API.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };